import { render, staticRenderFns } from "./InboxContextMenu.vue?vue&type=template&id=84b88348&"
import script from "./InboxContextMenu.vue?vue&type=script&lang=js&"
export * from "./InboxContextMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports